import { useHtmlToCanvasFactory } from '@gohighlevel/ghl-proposals-common'

export const useHtmlToCanvas = () => {
  const htmlToCanvasFactory = useHtmlToCanvasFactory()
  return htmlToCanvasFactory
}
